export enum RiderType {
    ALL = 1,
    SPECIFIC = 2,
}

